import { REDUCER_NAME } from './const'

const NS = REDUCER_NAME + '/'

export const TOGGLE_LOW_NPS_REASON = NS + 'TOGGLE_LOW_NPS_REASON'

export const SAVE_LOW_NPS_REASON_REQUEST = NS + 'SAVE_LOW_NPS_REASON_REQUEST    '

export const SAVE_LOW_NPS_REASON_SUCCESS = NS + 'SAVE_LOW_NPS_REASON_SUCCESS'

export const SAVE_LOW_NPS_REASON_ERROR = NS + 'SAVE_LOW_NPS_REASON_ERROR'

export const GET_FEEDBACK_REQUEST = NS + 'GET_FEEDBACK_REQUEST'

export const GET_FEEDBACK_DETAILS_SUCCESS = NS + 'GET_FEEDBACK_DETAILS_SUCCESS'

export const GET_FEEDBACK_DETAILS_ERROR = NS + 'GET_FEEDBACK_DETAILS_ERROR'




// WEBPACK FOOTER //
// ./src/modules/feedback/state/type.js